export const COMPANY_NAME = "엔라이튼 주식회사";
export const COMPANY_CEO = "이영호";
export const COMPANY_ADDR = "서울특별시 송파구 올림픽로 289, 잠실시그마타워 4층";
export const COMPANY_ID = "884-88-00541";
export const COMPANY_REPORT_NUM = "2024-서울송파-0192호";